<template>
  <div class="materiel-container">
    <!-- 搜索栏 -->
    <van-search
      v-model="searchKeyword"
      placeholder="搜索物料标题或物料ID"
      @search="getList(1)"
      show-action
    >
      <template #action>
        <div @click="handleRefresh">刷新</div>
      </template>
    </van-search>

    <!-- 新增按钮 -->
    <div class="add-btn-wrapper">
      <van-button type="primary" size="small" @click="showAddDialog">+ 新增物料</van-button>
    </div>

    <!-- 物料列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getList"
    >
      <van-card
        v-for="item in materielList"
        :key="item.id"
        :num="item.id"
        :price="`¥${item.purchasePrice || 0}`"
        :desc="item.productInfo"
        :title="item.productTitle"
        :thumb="item.productImage"
        @click="() => {}"
      >
        <template #tags>
          <van-tag plain type="primary" style="margin-right: 8px;"
            >{{ item.materielUniqueId }}</van-tag
          >
        </template>
        <template #footer>
          <div class="card-footer">
            <van-button
              size="mini"
              type="primary"
              @click="showEditDialog(item)"
            >
              编辑
            </van-button>
            <van-button
              size="mini"
              type="danger"
              @click="showDeleteConfirm(item)"
            >
              删除
            </van-button>
          </div>
        </template>
      </van-card>
    </van-list>

    <!-- 新增物料对话框 -->
    <add-dialog ref="addDialog" @success="getList(1)"></add-dialog>

    <!-- 编辑物料对话框 -->
    <edit-dialog ref="editDialog" @success="getList(1)"></edit-dialog>
  </div>
</template>

<script>
import AddDialog from './AddDialog.vue';
import EditDialog from './EditDialog.vue';

export default {
  components: {
    AddDialog,
    EditDialog,
  },
  data() {
    return {
      searchKeyword: '',
      pageSize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      finished: false,
      materielList: [],
    };
  },
  methods: {
    getList(page = null) {
      if (page) {
        this.currentPage = page;
        this.finished = false;
      }

      this.loading = true;
      this.axios
        .post('/Materiel/GetList', {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          searchKeyword: this.searchKeyword,
        })
        .then((response) => {
          this.loading = false;
          if (response.data.code === 101) {
            const data = response.data.data || { total: 0, data: [] };
            const newList = data.data || [];

            if (this.currentPage === 1) {
              this.materielList = newList;
            } else {
              this.materielList = [...this.materielList, ...newList];
            }

            this.total = data.total || 0;

            if (
              this.materielList.length >= this.total ||
              newList.length < this.pageSize
            ) {
              this.finished = true;
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleRefresh() {
      this.currentPage = 1;
      this.finished = false;
      this.getList(1);
      this.$toast('刷新成功');
    },

    showAddDialog() {
      this.$refs.addDialog.open();
    },

    showEditDialog(item) {
      this.$refs.editDialog.open(item);
    },

    showDeleteConfirm(item) {
      this.$dialog.confirm({
        title: '删除物料',
        message: `确定要删除物料 "${item.productTitle}" 吗？`,
      })
        .then(() => {
          this.deleteMateriel(item.id);
        })
        .catch(() => {});
    },

    deleteMateriel(id) {
      this.axios
        .post('/Materiel/Delete', { id })
        .then((response) => {
          if (response.data.code === 101) {
            this.$toast.success('删除成功');
            this.getList(1);
          } else {
            this.$toast.fail(response.data.msg || '删除失败');
          }
        })
        .catch(() => {
          this.$toast.fail('删除失败');
        });
    },
  },

  mounted() {
    document.title = '物料管理';
    this.getList();
  },
};
</script>

<style scoped>
.materiel-container {
  padding-bottom: 20px;
}

.add-btn-wrapper {
  padding: 10px;
  display: flex;
  justify-content: center;
}

.card-footer {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
</style>